import * as React from 'react';
import type { ButtonFullProps } from '../Button/Button';
import Button from '../Button/Button';
import useWindowResize from '../../../hooks/useWindowResize';
import DropdownPopup from '../DropdownPopup/DropdownPopup';
import cn from '~modules/cn';
import Styles from './foldable-button-view.module.scss';

type Props = {
    foldWidth?: number;
    childrenClassName?: string;
    children?: React.ReactNode | ((opts: { setToggled?: (state: boolean) => void }) => JSX.Element);
    buttonProps?: Partial<ButtonFullProps>;
    // for storybook topbar stories until better times
    window?: Window;
};

const FoldableButtonView = (props: Props) => {
    const { foldWidth = 0 } = props;
    const { width: windowWidth } = useWindowResize(props.window);
    const toggleHandlerRef = React.useRef<(state: boolean) => void | undefined>();
    const children = typeof props.children === 'function' ? props.children({ setToggled: toggleHandlerRef.current }) : props.children;

    return windowWidth >= foldWidth ? (
        <>{children}</>
    ) : (
        <DropdownPopup
            renderTrigger={(triggerProps, dropdownProps) => {
                toggleHandlerRef.current = dropdownProps.setToggled;
                return <Button type="button" buttonType="secondary" active={dropdownProps.isToggled} {...props.buttonProps} {...triggerProps} />;
            }}
        >
            <div className={cn(Styles.container, props.childrenClassName)}>{children}</div>
        </DropdownPopup>
    );
};

export default FoldableButtonView;
